import styled from 'styled-components'

export const Main = styled.main`
  display: flex;
  flex-direction: column;

  width: 50%;

  background: #FFFFFF;
  border: 1px solid #EFF2F7;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.02);
  border-radius: 7px;

  padding: 3.125rem;
  gap: 0.625rem;

  @media (max-width: 768px)
  {
    padding: 2rem;
    width: 100%;
  }
`

export const PreSingUpForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const MenuNamuBusinessLogo = styled.div`
  width: 119.81px;
  height: 38.32px;
  margin-left: 1rem;

  @media (max-width: 800px)
  {
    margin-left: .5rem;
  }
`

export const MenuBusinessImageContainer = styled.div`
  width: 152px;
  height: 41px;

  @media (max-width: 800px)
  {
    width: 122px;
  }
`

export const MenuBusinessImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

export const MenuImageElipseContainer = styled.div`
  width: 92.7px;
  height: 92.7px;
`

export const MenuImage = styled.img`
  object-fit: contain;
`

export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 0px 32px;
  margin-bottom: 3rem;
`

export const CheckImg = styled.img`
  width: 90px;
  height: 90px;
  object-fit: contain;
`